import React from 'react';
import CellAbstract from './CellAbstract';
import BinaryMultipleLayers from '../../UI/binaryComponents/BinaryMultipleLayers';
import { CELL_SEGMENT_PROPS } from './Types';
import { Position } from '../../../dispatcher/Types';

class CellSegment extends CellAbstract<CELL_SEGMENT_PROPS, {}> {
  render() {
    const {
      dataIndex,
      dataItem,
      field,
      columnDataIndex
    } = this.props;
    let columnField: string;
    columnField = field || columnDataIndex;
    const data = dataItem?.[columnField];
    const highLights = dataItem?.[`${columnField}Highlight`];
    const tagMap = (
      <BinaryMultipleLayers
        dataItem={{ data, highLights, dataItem: { ...dataItem, field } }}
      />);
    
    return this.renderCell(
      (typeof data !== 'string' && data !== undefined) ?
        <>
          {tagMap}
        </> : 
        <span
          className="tp-auto-height-cell-inner"
        >
          {dataItem[(columnField || dataIndex)]}
        </span>
    );
  }
}

export default CellSegment;
